export const GET_USER_APIS_REQUEST = 'GET_USER_APIS_REQUEST'
export const GET_USER_APIS_SUCCESS = 'GET_USER_APIS_SUCCESS'
export const GET_USER_APIS_FAILURE = 'GET_USER_APIS_FAILURE'
export const API_ASSIGN_PARAMETERS_REQUEST = 'API_ASSIGN_PARAMETERS_REQUEST'
export const API_ASSIGN_PARAMETERS_SUCCESS = 'API_ASSIGN_PARAMETERS_SUCCESS'
export const API_ASSIGN_PARAMETERS_FAILURE = 'API_ASSIGN_PARAMETERS_FAILURE'
export const CREATE_API_OBJECT_REQUEST = 'CREATE_API_OBJECT_REQUEST'
export const CREATE_API_OBJECT_SUCCESS = 'CREATE_API_OBJECT_SUCCESS'
export const CREATE_API_OBJECT_FAILURE = 'CREATE_API_OBJECT_FAILURE'
export const CREATE_API_REQUEST = 'CREATE_API_REQUEST'
export const CREATE_API_SUCCESS = 'CREATE_API_SUCCESS'
export const CREATE_API_FAILURE = 'CREATE_API_FAILURE'
export const READ_API_REQUEST = 'READ_API_REQUEST'
export const READ_API_SUCCESS = 'READ_API_SUCCESS'
export const READ_API_FAILURE = 'READ_API_FAILURE'
export const UPDATE_API_REQUEST = 'UPDATE_API_REQUEST'
export const UPDATE_API_SUCCESS = 'UPDATE_API_SUCCESS'
export const UPDATE_API_FAILURE = 'UPDATE_API_FAILURE'
export const DELETE_API_REQUEST = 'DELETE_API_REQUEST'
export const DELETE_API_SUCCESS = 'DELETE_API_SUCCESS'
export const DELETE_API_FAILURE = 'DELETE_API_FAILURE'
export const API_PAGE_HYDRATE = 'API_PAGE_HYDRATE'
export const API_PAGE_SUCCESS = 'API_PAGE_SUCCESS'
export const API_PAGE_FAILURE = 'API_PAGE_FAILURE'
export const REMOVE_KEY_FROM_API_REQUEST = 'REMOVE_KEY_FROM_API_REQUEST'
export const REMOVE_KEY_FROM_API_SUCCESS = 'REMOVE_KEY_FROM_API_SUCCESS'
export const REMOVE_KEY_FROM_API_FAILURE = 'REMOVE_KEY_FROM_API_FAILURE'
